import { Modal } from "react-bootstrap";
import useStore from "../hooks/useStore";
import { useEffect, useState } from "react";
import { itemDisplayName } from "../utils/storeItem";

export default function PopularItemModal() {
  const {
    showPopularItemModal,
    setShowPopularItemModal,
    setSelectedPopularItem,
    selectedPopularItem,
    setShowFindClientModal,
    selectedClient,
    setShowCheckoutModal,
  } = useStore();

  const [image, setImage] = useState(null);
  const [quantity, setQuantity] = useState(1);

  const updateQuantity = (qty) => {
    setQuantity((prevQuantity) =>
      Math.max(1, Math.min(prevQuantity + qty, 99))
    );
  };

  useEffect(() => {
    if (!selectedPopularItem) return;
    setSelectedPopularItem((prevItem) => ({
      ...prevItem,
      quantity: quantity,
    }));
  }, [quantity]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (showPopularItemModal) {
      setImage(pickRandomImage());
      setQuantity(1);
    }
  }, [showPopularItemModal]); // eslint-disable-line react-hooks/exhaustive-deps

  const randomImages = [
    "https://api.flowyogatx.com/assets/images/1.jpg",
    "https://api.flowyogatx.com/assets/images/2.jpg",
    "https://api.flowyogatx.com/assets/images/3.jpg",
    "https://api.flowyogatx.com/assets/images/4.jpg",
    "https://api.flowyogatx.com/assets/images/5.jpg",
    "https://api.flowyogatx.com/assets/images/6.jpg",
    "https://api.flowyogatx.com/assets/images/7.jpg",
  ];

  const pickRandomImage = () => {
    return randomImages[Math.floor(Math.random() * randomImages.length)];
  };

  const handleClose = () => setShowPopularItemModal(false);

  const handleBuy = () => {
    setSelectedPopularItem((prevItem) => ({
      ...prevItem,
      quantity: quantity,
    }));
    setShowPopularItemModal(false);
    if (selectedClient) setShowCheckoutModal(true);
    else if (selectedPopularItem.type === "product") setShowCheckoutModal(true);
    else setShowFindClientModal(true);
  };

  return (
    <Modal
      show={showPopularItemModal}
      onHide={handleClose}
      centered
      size="xl"
    >
      <Modal.Body className="p-0">
        <button
          type="button"
          className="btn-close"
          data-testid="item-modal-close-btn"
          onClick={handleClose}
        ></button>

        {selectedPopularItem && (
          <div className="row">
            <div
              className="col-md-6 image-container"
              style={{
                backgroundImage: `url(
                ${image}
              )`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "cover",
                borderRadius: "1.3rem 0px 0px 1.3rem",
                minHeight: 300,
              }}
            ></div>
            <div className="col-md-6 p-5 align-self-center">
              <h3>
                <span className="heading fw-bold">
                  {itemDisplayName(selectedPopularItem)}
                </span>
                <span className="fw-light d-block pt-2">
                  <small
                    style={{
                      position: "relative",
                      top: "-2px",
                    }}
                  >
                    $
                  </small>
                  <span className="price mt-3">
                    {selectedPopularItem.price}{" "}
                  </span>
                </span>
              </h3>
              <div
                className="description mb-3"
                dangerouslySetInnerHTML={{
                  __html: selectedPopularItem.description,
                }}
              />
              <div className="row mt-5">
                <div className="col">
                  {selectedPopularItem.type === "product" && (
                    <div className="d-flex align-items-center">
                      <button
                        className="btn btn-lg btn-outline-secondary"
                        data-testid="item-qty-minus-btn"
                        onClick={() => updateQuantity(-1)}
                      >
                        -
                      </button>
                      <span className="mx-3">{quantity}</span>
                      <button
                        className="btn btn-lg btn-outline-secondary"
                        data-testid="item-qty-plus-btn"
                        onClick={() => updateQuantity(+1)}
                      >
                        +
                      </button>
                    </div>
                  )}
                </div>
                <div className="col-auto">
                  <a className="btn btn-primary btn-lg" data-testid="item-buy-btn" onClick={handleBuy}>
                    Buy
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
